'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/context/Auth';
import { ResponseSchema } from '@/api/types';
import Axios from '@/lib/axiosConfig';

export interface EducationCategory {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

type GetEducationCategoriesRes = ResponseSchema<{
  count: number;
  rows: EducationCategory[];
}>;

export const useEducationCategories = () => {
  const { getAPIRequestTokenHeaders } = useAuth();

  return useQuery<GetEducationCategoriesRes>({
    queryKey: ['educations/categories'],
    queryFn: async () => {
      const headers = await getAPIRequestTokenHeaders();

      const { data } = await Axios.get(
        `https://api.weeamici.com/educations/categories`,
        { headers }
      );
      return data;
    },
  });
};
